module.exports = __webpack_public_path__ + "static/media/open-menu.a3501f16.svg";